import Vue from 'vue'
import Vuex from 'vuex'
import * as R from 'ramda'
import * as FilterHelper from '../utils/stationfilter'
import * as Utils from '../utils/utils'
import $ from 'jQuery'

const store = new Vuex.Store({
    state: {
        serverCantonFilters: [],
        serverCapabilityFilters: [],
        strings: [],
        baseFilters: null,

        selectedCantons: [],
        selectedCapabilityFilters: {},

        filteredStations: [],
        filteredStationsForCantonCount: [],
        filteredStationsForORCapabilityCount: [],
        filteredStationsForANDCapabilityCount: [],
        filteredStationsForMigrolcardCount: [],

        selectedStation: null,
        stationDetails: null,
        allStations: [],

        userLocation: null,
        currentFilterViewComponent: 'search-box',
        supressFilterZoomingOnce: false,

        searchString: '',
        mapCanonicalLink: ''
    },
    mutations: {
        //server data
        initFromServer(state, serverData) {
            state.serverCapabilityFilters = serverData.capabilityfilters;
            state.serverCantonFilters = serverData.kantonsfilter;
            state.baseFilters = serverData.baseFilters;

            //initialize distance property
            serverData.fillingstations.forEach(function (station) { station.distance = 0; });
            state.allStations = serverData.fillingstations;

            //init canonical link
            state.mapCanonicalLink = serverData.canonical;
        },
        setStationDetails(state, details) {
            state.stationDetails = details;
        },
        setStrings(state, strings) {
            state.strings = strings;
        },

        //state
        setSelectedStation(state, station) {
            state.selectedStation = station;
        },

        setUserLocation(state, location) {
            state.userLocation = location;
        },

        setCurrentFilterViewComponent(state, component) {
            state.currentFilterViewComponent = component;
        },

        setSupressFilterZoomingOnce(state, newValue) {
            state.supressFilterZoomingOnce = newValue;
        },

        //filters
        setSearchString(state, newValue) {
            state.searchString = newValue;
        },

        setSelectedCantons(state, newValue) {
            state.selectedCantons = newValue;
        },

        addCapabilityFilter(state, filter) {
            //check if there is already a filter property with this group-name defined, if not, initialize it
            if (state.selectedCapabilityFilters[filter.group] === undefined)
                Vue.set(state.selectedCapabilityFilters, filter.group, []);

            //now add the filter, if it isn't there yet
            var index = R.findIndex(R.propEq('filter', filter.filter))(state.selectedCapabilityFilters[filter.group]);
            if (index === -1)
                state.selectedCapabilityFilters[filter.group].push(filter);
        },

        removeCapabilityFilter(state, filter) {
            //check if there is already a filter property with this group-name defined, if not, initialize it
            if (state.selectedCapabilityFilters[filter.group] === undefined)
                Vue.set(state.selectedCapabilityFilters, filter.group, []);

            //now remove the filter, if it is there
            var index = R.findIndex(R.propEq('filter', filter.filter))(state.selectedCapabilityFilters[filter.group]);
            if (index !== -1)
                state.selectedCapabilityFilters[filter.group].splice(index, 1);
        },

        clearFilters(state) {
            state.selectedCapabilityFilters = {};
            state.selectedCantons = [];
        },

        filtered(state, results) {
            state.filteredStations = results.filteredStations;
            state.filteredStationsForCantonCount = results.filteredStationsForCantonCount;
            state.filteredStationsForORCapabilityCount = results.filteredStationsForORCapabilityCount;
            state.filteredStationsForANDCapabilityCount = results.filteredStationsForANDCapabilityCount;
            state.filteredStationsForMigrolcardCount = results.filteredStationsForMigrolcardCount;
        }
    },
    actions: {
        //server data
        async loadMapData({ state, commit, dispatch }) {
            return new Promise((resolve, reject) => {
                $.getJSON('/migrolapi/' + window.CONFIG.language + '/tankstellen')
                    .then(serverData => {
                        commit('initFromServer', serverData);

                        //now apply default filters
                        var urlParams = new URLSearchParams(window.location.search);
                        if (urlParams.get('ts') == '1' || urlParams.get('filter') == 'ts') {
                            dispatch('addCapabilityFilter', { filter: state.baseFilters.tankstelle, preventUIUpdate: true });
                        }
                        if (urlParams.get('cw') == '1' || urlParams.get('filter') == 'cw') {
                            dispatch('addCapabilityFilter', { filter: state.baseFilters.carwash, preventUIUpdate: true });
                        }
                        if (urlParams.get('ws') == '1' || urlParams.get('filter') == 'ws') {
                            dispatch('addCapabilityFilter', { filter: state.baseFilters.autoservice, preventUIUpdate: true });
                        }
                        if (urlParams.get('fc') == '1' || urlParams.get('filter') == 'fc') {
                            dispatch('addCapabilityFilter', { filter: state.baseFilters.fastcharging, preventUIUpdate: true });
                        }
                        if (urlParams.get('mc') == '1' || urlParams.get('filter') == 'mc') {
                            //migrolcard filter is reversed, so do nothing here...
                        } else {
                            dispatch('addCapabilityFilter', { filter: state.baseFilters.migrolcard, preventUIUpdate: true }); //show only migrol tankstellen by default
                        }

                        dispatch('filterStations').then(() => {
                            //zoom to selected location (if any), after filtering
                            if (urlParams.get('station')) {
                                var stationId = parseInt(urlParams.get('station'));
                                var index = R.findIndex(R.propEq('id', stationId))(state.filteredStations);
                                if (index !== -1) {
                                    dispatch('selectStation', state.filteredStations[index]);
                                }
                            } else if (urlParams.get('lat') && urlParams.get('lng')) {
                                dispatch('setUserLocation', { latitude: +urlParams.get('lat'), longitude: +urlParams.get('lng') });
                            }
                        });

                        if (urlParams.get('addr') && urlParams.get('addr').length >= 3) {
                            commit('setSearchString', urlParams.get('addr'));
                        }

                        resolve();
                    })
                    .catch(error => {
                        console.error(error);
                        reject();
                    });
            });
        },
        async loadDetailsData({ commit }, detailsurl) {
            return new Promise((resolve, reject) => {
                $.getJSON('/migrolapi/' + window.CONFIG.language + '/tankstellen/' + detailsurl)
                    .done(details => {
                        commit('setStationDetails', details);
                        resolve();
                    })
                    .fail((error) => {
                        console.error(error.status);
                        if (error.status === 404) {
                            window.location = '/' + window.CONFIG.language + '/404';
                        } else {
                            reject();
                        }
                    });
            });
        },
        loadStrings({ commit }) {
            $.getJSON('/migrolapi/' + window.CONFIG.language + '/tankstellen/strings')
                .done(strings => {
                    commit('setStrings', strings);
                });
        },

        //state
        setFilterViewComponent({ commit }, component) {
            commit('setCurrentFilterViewComponent', component);
        },
        deactivateSupressFilterZoomingOnce({ commit }) {
            commit('setSupressFilterZoomingOnce', false);
        },

        //filters
        addCantonFilter({ state, commit, dispatch }, args) {
            //this does a union of the two arrays (no duplicates)
            var newArray = R.union(state.selectedCantons, args.filter);
            commit('setSelectedCantons', newArray);
            if (!args.preventUIUpdate)
                dispatch('filterStations');
        },
        removeCantonFilter({ state, commit, dispatch }, args) {
            //this removes all elements from cantonsToRemove from selectedCantons
            var newArray = R.without(args.filter, state.selectedCantons);
            commit('setSelectedCantons', newArray);
            if (!args.preventUIUpdate)
                dispatch('filterStations');
        },

        addCapabilityFilter({ state, commit, dispatch }, args) {
            commit('addCapabilityFilter', args.filter);

            if (args.filter.group === 'a_null') {
                //for top level filters with OR-filtered children, also tick all children, if parent is checked
                var serverFilter = R.find(R.propEq('filter', args.filter.filter))(state.serverCapabilityFilters);
                //if the children are or-filtered, check them all as well
                if (serverFilter && serverFilter.children && serverFilter.children.length > 0 && serverFilter.children[0].group.indexOf('o_') === 0) {
                    for (var i = 0; i < serverFilter.children.length; i++) {
                        commit('addCapabilityFilter', serverFilter.children[i]);
                    }
                }
            }
            else if (args.filter.group.indexOf('o') === 0) {
                //for OR filters, also add parent filter, if not already there
                var parentFilter = R.find(R.propEq('filter', parseInt(args.filter.group.substr(2))))(state.serverCapabilityFilters);
                if (parentFilter)
                    commit('addCapabilityFilter', parentFilter);
            }

            if (!args.preventUIUpdate)
                dispatch('filterStations');
        },
        removeCapabilityFilter({ state, commit, dispatch }, args) {
            commit('removeCapabilityFilter', args.filter);

            if (args.filter.group === 'a_null') {
                //for top level filters with OR-filtered children, also untick all children, if parent is unchecked
                var serverFilter = R.find(R.propEq('filter', args.filter.filter))(state.serverCapabilityFilters);
                //if the children are or-filtered, check them all as well
                if (serverFilter && serverFilter.children && serverFilter.children.length > 0 && serverFilter.children[0].group.indexOf('o_') === 0) {
                    for (var i = 0; i < serverFilter.children.length; i++) {
                        commit('removeCapabilityFilter', serverFilter.children[i]);
                    }
                }
            }
            else if (args.filter.group.indexOf('o') === 0) {
                //for OR filters, remove parent filter, if no other or-siblings are ticked anymore
                if (!state.selectedCapabilityFilters[args.filter.group] || state.selectedCapabilityFilters[args.filter.group].length == 0) {
                    //no filters with the current group found in the selectedCapabilityFilter array -> untick parent
                    var parentFilter = R.find(R.propEq('filter', parseInt(args.filter.group.substr(2))))(state.serverCapabilityFilters);
                    if (parentFilter)
                        commit('removeCapabilityFilter', parentFilter);
                }
            }

            if (!args.preventUIUpdate)
                dispatch('filterStations');
        },

        resetAllFilters({ state, commit, dispatch }) {
            commit('clearFilters');
            dispatch('addCapabilityFilter', { filter: state.baseFilters.migrolcard, preventUIUpdate: true }); //show only migrol tankstellen by default
            dispatch('filterStations');
        },

        //the big filter method
        filterStations({ commit, state, dispatch }) {

            //clear selected station
            dispatch('selectStation', null);

            //recalculate the distances for all stations
            let allStationsWithUpdatedDistance = state.allStations;
            allStationsWithUpdatedDistance.forEach(function (station) {
                if (state.userLocation == null || !station.latitude || !station.longitude)
                    station.distance = null;
                else
                    station.distance = Utils.calculateDistance(state.userLocation.latitude, state.userLocation.longitude, station.latitude, station.longitude);
            });

            //define the filter methods
            const cantonFilter = R.filter(FilterHelper.createFilterByCantonFunction(state.selectedCantons));
            const capabilityFilter = R.filter(FilterHelper.createFilterByCapabilitiesFunction(state.selectedCapabilityFilters, false));
            const capabilityFilterIgnoreOr = R.filter(FilterHelper.createFilterByCapabilitiesFunction(state.selectedCapabilityFilters, true));
            const capabilityFilterIgnoreOrExludingMigrolcard = R.filter(FilterHelper.createFilterByCapabilitiesFunction(state.selectedCapabilityFilters, false, true));

            commit('filtered', {
                //full filter applied
                filteredStations: R.pipe(cantonFilter, capabilityFilter)(allStationsWithUpdatedDistance),
                //only capability filter applied, is used for showing amounts in cantons filter
                filteredStationsForCantonCount: R.pipe(capabilityFilter)(allStationsWithUpdatedDistance),
                //only canton and capability and-filters applied, is used for showing amounts in OR-capabilities filter
                filteredStationsForORCapabilityCount: R.pipe(cantonFilter, capabilityFilterIgnoreOr)(allStationsWithUpdatedDistance),
                //only canton and capability filters applied, is used for showing amounts in AND-capabilities filter
                filteredStationsForANDCapabilityCount: R.pipe(cantonFilter, capabilityFilter)(allStationsWithUpdatedDistance),
                //only canton and capability and-filters applied, is used for showing amounts in migrolcard tab filter
                filteredStationsForMigrolcardCount: R.pipe(cantonFilter, capabilityFilterIgnoreOrExludingMigrolcard)(allStationsWithUpdatedDistance)
            });
        },

        setUserLocation({ commit, dispatch }, location) {
            commit('setSupressFilterZoomingOnce', true);
            if (location == null)
                commit('setUserLocation', null);
            else
                commit('setUserLocation', { latitude: location.latitude, longitude: location.longitude });
            //now filter stations, so the distances get updated
            dispatch('filterStations');
        },

        selectStation({ commit }, station) {
            commit('setSelectedStation', station);
        }
    }
});
export default store;